import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { /*useNavigate,*/ useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { Meta, Rating, StockAlert } from '../components';
import Loader from '../components/Loader';
import { addToCart } from '../redux/actions/cartActions';
import BreadCrumb from '../ScreenComponents/ShearCompo/BreadCrumb/BreadCrumb';
import {
  createProductReview,
  getProductDetails,
} from '../redux/actions/productActions';
import './Css/ProductScreen.scss';
import { FaAngleDown, FaAngleRight, FaFacebookF } from 'react-icons/fa';
import { AiOutlineHeart, AiOutlineShareAlt, AiOutlineTwitter } from 'react-icons/ai';
import { FiCopy } from 'react-icons/fi';
import ChoiceCarousel from '../ScreenComponents/HomeCompo/Carousel/ChoiceCarousel';
import RightSideModal from '../components/ModalLayout/RightSideModal';
import ReadMoreContent from '../ScreenComponents/ReadMore/ReadMore';
import LatestArrivalCarousel from '../ScreenComponents/HomeCompo/Carousel/LatestArrivalCarousel';

const ProductScreen = () => {
  const { product, loading } = useSelector(state => state.productDetails);

  const params = useParams();
  // const navigate = useNavigate();

  const productId = params.id;
  const dispatch = useDispatch();
  const [getActive, setActive] = useState({
    description: true,
    information: false,
    review: false
  })
  const [quantity, setQuantity] = useState(1);
  const [modalShow, setModalShow] = useState(false);
  const { cartItems, loading: cartLoading } = useSelector(state => state.cart);
  const handleClose = () => setModalShow(false);
  // set stock quantity
  useEffect(() => {
    if (product?.countInStock !== 0) {
      if (quantity > product?.countInStock) {
        setQuantity(product?.countInStock);
      }
      if (quantity < 1) {
        setQuantity(1);
      }
    }
  }, [quantity, product?.countInStock]);

  const { id } = useParams();
  const newCartItems = cartItems.filter(data => data.product === id);

  const [rating, setRating] = useState(1);
  const [comment, setComment] = useState('');
  const { user } = useSelector(state => state.userLogin);
  const {
    success: reviewCreatedSuccess,
    loading: reviewCreatedLoading,
  } = useSelector(state => state.productReviewCreate);

  useEffect(() => dispatch(getProductDetails(productId)), [
    dispatch,
    productId,
    reviewCreatedSuccess,
  ]);

  const addToCartHandler = () => {
    dispatch(addToCart(productId, quantity));
    // navigate(`/cart/${productId}?qty=${quantity}`);
  };

  const onSubmit = e => {
    e.preventDefault();
    dispatch(createProductReview(productId, { rating, comment }));
  };

  const imgArr = [
    {
      img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img1.png",
    },
    {
      img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img10.png",
    },
    {
      img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img2.png",
    },
    {
      img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img3.png",
    },
    {
      img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img4.png",
    },
    {
      img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img5.png",
    },
    {
      img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img6.png",
    },
  ];

  return loading ? (
    <Loader />
  ) : (
    <motion.div
      exit={{ opacity: 0 }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      id="single__product__page"
      className='space-y-5 divide-y divide-gray-100'
    >
      {cartLoading && <Loader />}
      <Meta title={product?.name} />
      <div className='shop_single_products'>
        <BreadCrumb title={<span className=" d-flex items-end h-auto">
          <Link className="link" to='/'>Home</Link>
          <div className="d-flex items-center">
            <FaAngleRight className='shop_icon' />
            <Link className="link" to='/shop'>Shop</Link>
            <FaAngleRight className='shop_icon' />
            <span className="notLink">{product?.category}</span>
          </div>
        </span>} />
        {reviewCreatedLoading && <Loader />}
        <div className='row product_details mt-5'>
          <div className='col-lg-7 col-xl-6 mb-5 d-flex product_img'>
            <div className='hidden md:block left_small_img'>
              <div>
                <motion.img
                  exit={{ opacity: 0 }}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.2, delay: 0.3 }}
                  src={product?.image}
                  alt=''
                  className='w-100 max-w-md'
                />
              </div>
              <div>
                <motion.img
                  exit={{ opacity: 0 }}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.2, delay: 0.3 }}
                  src={product?.image}
                  alt=''
                  className='mx-auto w-100 max-w-md'
                />
              </div>
            </div>
            <div className='big_img'>
              <motion.img
                exit={{ opacity: 0 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.2, delay: 0.3 }}
                src={product?.image}
                alt=''
                className=''
              />
            </div>
          </div>
          <div className='col-lg-5 col-xl-6'>
            <motion.div
              className='mx-auto max-w-sm md:max-w-full pl-0 xl:pl-5 product_info'
              variants={{
                hidden: { opacity: 0, y: 10 },
                visible: {
                  opacity: 1,
                  y: 0,
                  transition: {
                    staggerChildren: 0.3,
                    duration: 0.3,
                    delay: 0.3,
                  },
                },
              }}
              initial='hidden'
              animate='visible'
            >
              <div className='prevNextBtn d-flex justify-end'>
                <button>Previous</button>
                <button>Next</button>
              </div>
              <h2 className='title text-4xl md:text-5xl'>
                {product?.name}
              </h2>
              <span className='category text-md'>
                {product?.category.toUpperCase()}
              </span>
              <div className='price d-flex items-center'>
                <del className='regular'>৳ {product?.price}</del>
                <span className='final text-4xl md:text-5xl'>৳ {50}</span>
                <sup><StockAlert remaining={product?.countInStock} inStock={product?.countInStock > 0} /></sup>
              </div>
              <div className='size d-flex'>
                <div className="common sm">
                  <span className='top'>s</span>
                  <span className='bottom'>small</span>
                </div>
                <div className="common md">
                  <span className='top'>m</span>
                  <span className='bottom'>small</span>
                </div>
                <div className="common lh">
                  <span className='top'>l</span>
                  <span className='bottom'>large</span>
                </div>
                <div className="common xl">
                  <span className='top'>xl</span>
                  <span className='bottom'>Extra large</span>
                </div>
                <div className="common xxl">
                  <span className='top'>xll</span>
                  <span className='bottom'>Extra Extra Large</span>
                </div>
              </div>
              <div className='quantity_addToCart d-flex py-3 items-center'>
                <div className='quantity'>
                  <span className='inStock d-none'>In Stock: {product?.countInStock}</span>
                  <button
                    className={`commonBtn decrement `}
                    onClick={() => quantity > 1 && setQuantity(quantity - 1)}
                  >-</button>
                  <input type="number" value={quantity > product?.countInStock ? product?.countInStock : quantity} onChange={e => setQuantity(Number(e.target.value))} />
                  <button
                    className='commonBtn increment'
                    onClick={() => product?.countInStock > quantity && setQuantity(quantity + 1)}
                  >+</button>

                </div>
                <button
                  className={`addToCart ${product?.countInStock === 0 && 'opacity-50 pointer-events-none'
                    } btn`}
                  disabled={product?.countInStock === 0}
                  onClick={() => { addToCartHandler(); setModalShow(true); }}
                >
                  Add to cart
                </button>
                <RightSideModal show={modalShow} handleClose={handleClose}
                  modalBody={newCartItems && newCartItems.map((data, index) =>
                    <div key={index} className='modalData row pt-4'>
                      <div className='imgParent col-lg-4 mb-2'>
                        <img src={data?.image} alt={`${index}_cart_modal_img`} />
                      </div>
                      <div className='col-lg-8'>
                        <p className='title'>
                          {/* {data?.name} */}
                          Plain White T-shirt
                        </p>
                        <div className='product_details'>
                          <p className='text-decoration-underline text-uppercase smBoldFont'>Duplicate this order</p>
                          <p className='d-flex'>Color: White <span className='color d-block'></span></p>
                          <p className='d-flex'>Size: L <span className='color color2 d-flex items-center justify-center'><FaAngleDown /></span></p>
                          <div className='d-flex items-center'>
                            <p>Quantity:</p>
                            <div className='quantitySet ml-5 d-flex items-center'>
                              <button
                                className={`commonBtn decrement `}
                                onClick={() => quantity > 1 && setQuantity(quantity - 1)}
                              >-</button>
                              <input type="number" value={quantity > product?.countInStock ? product?.countInStock : quantity}
                                onChange={
                                  e => setQuantity(Number(e.target.value))
                                } />
                              <button
                                className='commonBtn increment'
                                onClick={() => product?.countInStock > quantity && setQuantity(quantity + 1)}
                              >+</button>
                            </div>
                          </div>
                          <p className='d-flex'>Category: lorem, lorem</p>
                          <p className='d-flex'>Unit Price: ৳450.00</p>
                          <p className='d-flex'>Total Price: ৳45000.00</p>

                          {/* <button
                            className={`addToCart ${product?.countInStock === 0 && 'opacity-50 pointer-events-none'
                              } btn`}
                            disabled={product?.countInStock === 0}
                            onClick={() => { addToCartHandler(); setModalShow(true); }}
                          >
                            Add to cart
                          </button> */}
                        </div>
                      </div>
                    </div>
                  )}
                />
              </div>
              <div className='description'>
                <p className='desc_title'>PRODUCT DETAILS</p>
                <ReadMoreContent description={`${product?.description} Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse placerat ornare est id tincidunt. In hac habitasse platea dictumst. Aliquam quis odio at mauris maximus ornare. Morbi id volutpat odio, eget pharetra arcu. Vivamus mi neque, fringilla in aliquet eget, condimentum sit amet nisi. Sed blandit, elit in ornare auctor, nibh lacus aliquet sem, quis mollis nulla velit nec ligula. Nulla varius, magna et hendrerit sollicitudin, nulla mi volutpat massa, sed gravida sem dolor quis purus. Nullam vel nunc vel justo ullamcorper porta. Aliquam posuere gravida massa in varius. auctor, nibh lacus aliquet sem, quis mollis nulla velit nec ligula. Nulla varius, magna et hendrerit sollicitudin, nulla mi volutpat massa.`} />
              </div>
              <div className='category_tags_social'>
                <p className='category'>Categories: {product?.category}, Lorem</p>
                <p className='tags'>Tags: {product?.category}, Lorem, Lorem, Shirt</p>
                <div className='social d-flex'>
                  <FaFacebookF />
                  <AiOutlineTwitter />
                  <FiCopy />
                </div>
              </div>
              <div className='wishlist_share d-flex'>
                <button className='wishlist btn'><AiOutlineHeart /> Add to Wishlist</button>
                <button className='share btn mx-3'><AiOutlineShareAlt /> Share</button>
              </div>
            </motion.div>
          </div>
        </div>
        <motion.div
          exit={{ opacity: 0 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className='pt-5 mx-auto max-w-sm md:max-w-full'
        >
          <div className='row mb-5 product_info_details'>
            <div className='col-md-6 mx-auto'>
              <div className='btnGrp mb-4 d-flex'>
                <button
                  className={`btn ${getActive.description && 'activeBtn'}`}
                  onClick={() => setActive({
                    description: true,
                    information: false,
                    review: false
                  })}
                >description</button>
                <button className={`btn ${getActive.information && 'activeBtn'}`}
                  onClick={() => setActive({
                    description: false,
                    information: true,
                    review: false
                  })}
                >information</button>
                <button className={`btn ${getActive.review && 'activeBtn'}`}
                  onClick={() => setActive({
                    description: false,
                    information: false,
                    review: true
                  })}
                >Reviews ({product?.numReviews})</button>
              </div>
              <div className='details_show'>
                <div className={` description ${!getActive.description && "d-none"}`}>
                  <p>{product?.description} Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse placerat ornare est id tincidunt. In hac habitasse platea dictumst. Aliquam quis odio at mauris maximus ornare. Morbi id volutpat odio, eget pharetra arcu. Vivamus mi neque, fringilla in aliquet eget, condimentum sit amet nisi. Sed blandit, elit in ornare auctor, nibh lacus aliquet sem, quis mollis nulla velit nec ligula.</p>
                  <p>Nulla varius, magna et hendrerit sollicitudin, nulla mi volutpat massa, sed gravida sem dolor quis purus. Nullam vel nunc vel justo ullamcorper porta. Aliquam posuere gravida massa in varius. auctor, nibh lacus aliquet sem, quis mollis nulla velit nec ligula. Nulla varius, magna et hendrerit sollicitudin, nulla mi volutpat massa.</p>
                </div>
                <div className={` information ${!getActive.information && "d-none"}`}>
                  <p>{product?.description} Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse placerat ornare est id tincidunt. In hac habitasse platea dictumst. Aliquam quis odio at mauris maximus ornare. Morbi id volutpat odio, eget pharetra arcu. Vivamus mi neque, fringilla in aliquet eget, condimentum sit amet nisi. Sed blandit, elit in ornare auctor, nibh lacus aliquet sem, quis mollis nulla velit nec ligula.</p>
                </div>
                <div className={` review ${!getActive.review && "d-none"}`}>
                  <div className='grid gap-10 md:grid-cols-2 '>
                    <div>
                      <h3 className='text-gray-700 text-2xl mb-10'>
                        Ratings & Reviews of {product?.name}
                      </h3>
                      {product?.numReviews === 0 && (
                        <h4 className='text-red-400'>
                          This product has no reviews. <br /> Let others know what do you
                          think and be the first to write a review.
                        </h4>
                      )}
                      <div className='divide-y divide-gray-200'>
                        {product?.reviews.map(review => (
                          <motion.div
                            key={review?._id}
                            variants={{
                              hidden: { opacity: 0, y: -20 },
                              visible: {
                                opacity: 1,
                                y: 0,
                                transition: { staggerChildren: 0.5 },
                              },
                            }}
                            initial='hidden'
                            animate='visible'
                            className='space-y-3'
                          >
                            <div className='flex items-center space-x-5'>
                              <img src={review?.avatar} alt='' className='w-10' />
                              <div>
                                <h2>{review?.name}</h2>
                                <Rating value={review?.rating} />
                              </div>
                            </div>
                            <p className='prose max-w-lg'>{review?.comment}</p>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                    {user ? (
                      <div>
                        <h3 className='text-gray-700 text-2xl mb-10'>
                          Write a customer review
                        </h3>
                        <form {...{ onSubmit }}>
                          <div className='flex flex-col space-y-5'>
                            <select
                              className='w-full lg:w-2/3 border-none bg-gray-100 rounded-md focus:ring-purple-100'
                              name='quantity'
                              id='quantity'
                              required
                              onChange={e => setRating(e.target.value)}
                            >
                              <option value=''>Select Rating...</option>
                              <option value='1'>1 - Poor</option>
                              <option value='2'>2 - Fair</option>
                              <option value='3'>3 - Good</option>
                              <option value='4'>4 - Very Good</option>
                              <option value='5'>5 - Excellent</option>
                            </select>
                            <textarea
                              className='w-full lg:w-2/3 border-none focus:ring-gray-200 transition-shadow duration-500 rounded-md bg-gray-100 px-5 overflow-hidden'
                              type='text'
                              placeholder='Comment'
                              onChange={e => setComment(e.target.value)}
                              required
                            />
                            <button className='w-40 bg-gray-900 focus:outline-none focus:ring-4 focus:ring-purple-200 text-white px-5 py-2 rounded-md transition-shadow duration-300'>
                              Submit Review
                            </button>
                          </div>
                        </form>
                      </div>
                    ) : (
                      <h3 className='text-gray-700 text-lg mb-10'>
                        Please{' '}
                        <Link to='/login' className='text-blue-500 hover:underline'>
                          Sign in
                        </Link>{' '}
                        to write a review
                      </h3>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
        <motion.div
          exit={{ opacity: 0 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className='pt-5 mx-auto max-w-sm md:max-w-full moreProductShow'
        >
          <h2>You may also like...</h2>
          <ChoiceCarousel arrows images={imgArr} />
          <h2>Related Products</h2>
          <br />
          <br />
          <LatestArrivalCarousel arrows images={imgArr} />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ProductScreen;
